module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/euro-d7adcdb5440dfbe692cebd7cfdd8eb65.webp";